import { http } from "@/utils/request";
import type { WordItemsResponse, GetWordsParams } from "@/types/word.types";

export const wordService = {
  // 获取单词列表
  getWords: async (params: GetWordsParams): Promise<WordItemsResponse> => {
    return http.get<WordItemsResponse>("/dict/list", params);
  },

  // 更新单词图片
  updateWordImage: async (id: string, pic_name: string): Promise<void> => {
    return http.put("/dict", {
      id,
      pic_name,
    });
  },
};
